import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./youtubefed.css";

const YouTubeFeed = () => {
  const videos = [
    {
      title: "Indian Space Journey - The comprehensive learning for Kids",
      url: "https://www.youtube.com/embed/n5LBMWhscq8",
      whatsappLink: "https://whatsapp.com/channel/0029VaMRw...",
      publishedAt: "17/08/2024, 10:30:26",
      duration: "1m 35s",
    },
    {
      title: "How To Adjust Hoop Ring",
      url: "https://www.youtube.com/embed/nz4ilsmExBw", 
      whatsappLink: "https://whatsapp.com/channel/0029VaMRw...",
      publishedAt: "17/08/2024, 10:00:19",
      duration: "1m 47s",
    },
    {
      title: "Level Up Your Hoop Art Skills with Knot-2",
      url: "https://www.youtube.com/embed/tY_65h5WiuM", 
      whatsappLink: "https://whatsapp.com/channel/0029VaMRw...",
      publishedAt: "17/08/2024, 09:15:02",
      duration: "1m 35s",
    },
    {
      title: "Indian Space Journey - Exploring space with school Kids",
      url: "https://www.youtube.com/embed/m_NKoOJXt6w", 
      whatsappLink: "https://whatsapp.com/channel/0029VaMRw...",
      publishedAt: "17/08/2024, 08:00:20",
      duration: "1m 24s",
    },
  ];
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">YOUTUBE FEED</h2>
      <div className="row">
        {videos.map((video, index) => (
          <div className="col-md-3 mb-4" key={index}>
            <div className="youtube-card h-100 shadow-sm">
              <iframe
                className="card-img-top"
                src={video.url}
                title={video.title}
                allowFullScreen
              ></iframe>
              <div className="card-body">
                <h5 className="card-title">{video.title}</h5>
                <p>
                  Click here to join our WhatsApp Channel
                  <br />
                  <a href={video.whatsappLink} target="_blank" rel="noreferrer">
                    {video.whatsappLink}
                  </a>
                </p>
                <p>Published At: {video.publishedAt}</p>
                <p>Duration: {video.duration}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default YouTubeFeed;
